
import Vue from 'vue';
import Component from 'vue-class-component';
import BaseLookup from './BaseLookup';
import TLookupSkin from './LookupSkin.vue';

@Component({
  name: 'WorkPlanLookup',
  components: {
    TLookupSkin,
  },
})
export default class WorkPlanLookup extends BaseLookup {
  dialogVisible = false;

  suggestionControllerName() {
    return 'WorkPlan';
  }

  openDialog() {
    this.dialogVisible = true;
  }

  keyPrefix() {
    return 'WorkPlan';
  }

  handleSelect(val) {
    this.addItem({
      key: val.key,
      title: val.value,
    });
  }

  linkClick(workPlanId, row) {
    const item = {
      key: `${this.keyPrefix()}-${workPlanId}`,
      title: row.TITLE.value,
    };
    this.addItem(item);
    if (!this.multipleSelection) {
      this.dialogVisible = false;
    }
  }
}
